module.exports = __webpack_public_path__ + "static/media/unsw.f5aea60f.png";